module.exports = __webpack_public_path__ + "static/media/hotWaterQuestion.d3c4f886.png";